import React from "react";
import { Card } from 'ui/components/card';
import { Separator } from 'ui/components/separator';
import { Button } from 'ui/components/button';
import { Icon } from "components";
import { LINK, PLUS } from "icons";
import ProfileIntegrationCardLoader from "./loader";

export default function ProfileIntegrationCard({
    icon,
    title,
    description,
    isConnected,
    link,
    onConnect,
    loading = false,
}) {
    if (loading) {
        return <ProfileIntegrationCardLoader />;
    }
    const handleOpen = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (link) {
            window.open(link, "_blank", "noopener,noreferrer");
        }
    };

    return (
        <Card className="h-max gap-0 py-1 border shadow-sm">
            <div className="p-4 md:p-6 space-y-4">
                <div className="flex justify-between items-center">
                    <div className="text-foreground">
                        <Icon icon={icon} className="size-10" />
                    </div>
                    {isConnected && link ? (
                        <Button variant="ghost" size="icon" onClick={handleOpen}>
                            <Icon icon={LINK} className="size-4" />
                        </Button>
                    ) : null}
                </div>
                <div>
                    <h3 className="text-lg font-semibold">{title}</h3>
                </div>
                {description ? (
                    <p className="text-sm text-muted-foreground">{description}</p>
                ) : null}
            </div>
            <Separator />
            <div className="px-4 md:px-6 py-4 flex justify-between items-center">
                {isConnected ? (
                    <span className="text-sm text-muted-foreground">Connected</span>
                ) : (
                    <Button className="gap-2" onClick={onConnect}>
                        <Icon icon={PLUS} className="size-4 text-white" />
                        Connect
                    </Button>
                )}
            </div>
        </Card>
    );
}

export { ProfileIntegrationCardLoader };


